import type { AlignmentGuide } from './card-resize';

/** Lineas de alineacion tipo Figma mientras se redimensiona una tarjeta. */
export function ResizeGuides({ guides }: { readonly guides: readonly AlignmentGuide[] }) {
  if (guides.length === 0) return null;
  return (
    <div aria-hidden className="pointer-events-none absolute inset-0 z-30 overflow-hidden">
      {guides.map((guide) =>
        guide.axis === 'x' ? (
          <div
            key={`x:${String(guide.position)}:${String(guide.start)}`}
            className="absolute w-px bg-[#ff4dff]"
            style={{
              left: guide.position,
              top: Math.min(guide.start, guide.end),
              height: Math.abs(guide.end - guide.start),
            }}
          />
        ) : (
          <div
            key={`y:${String(guide.position)}:${String(guide.start)}`}
            className="absolute h-px bg-[#ff4dff]"
            style={{
              top: guide.position,
              left: Math.min(guide.start, guide.end),
              width: Math.abs(guide.end - guide.start),
            }}
          />
        ),
      )}
    </div>
  );
}
